import { render, staticRenderFns } from "./PolicyManage.vue?vue&type=template&id=2eb1da56&"
import script from "./PolicyManage.vue?vue&type=script&lang=js&"
export * from "./PolicyManage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports